import { createSlice } from '@reduxjs/toolkit'
import { setUserAttributes } from '../../analytics'

const initialState = {
  userDetailsState: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
}

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    getUserDetailsRequest: (state, action) => {
      state.userDetailsState = {
        ...state.userDetailsState,
        loading: true,
        error: null,
        success: false,
        data: null,
      }
    },
    getUserDetailsSuccess: (state, action) => {
      state.userDetailsState = {
        ...state.userDetailsState,
        loading: false,
        error: null,
        success: true,
        data: action.payload,
      }
      setUserAttributes(action.payload)
    },
    getUserDetailsError: (state, action) => {
      state.userDetailsState = {
        ...state.userDetailsState,
        loading: false,
        data: null,
        success: false,
        error: action.payload,
      }
    },
    resetUserDetails: (state, action) => {
      state.userDetailsState = {
        ...state.userDetailsState,
        loading: false,
        data: null,
        success: false,
        error: null,
      }
    },
  },
})

export const {
  getUserDetailsRequest,
  getUserDetailsSuccess,
  getUserDetailsError,
  resetUserDetails,
} = authenticationSlice.actions

export default authenticationSlice.reducer
